import axios from "axios";
import { req, reqF } from "./axiosFun";
import { reqBlob } from "./exportFile";

// 分页获取入库单信息列表
export const GetInputStorePageList = (params) => {
	return reqF("post", "/api/sysConfig/Receipt/GetInputStorePageList", params);
};
// 保存入库单信息
export const SaveInputStore = (params) => {
	return reqF("post", "/api/sysConfig/Receipt/SaveInputStore", params);
};
// 获取入库单信息详情
export const GetInputStoreDeatail = (params) => {
	return reqF("post", "/api/sysConfig/Receipt/GetInputStoreDeatail", params);
};
// 删除入库单信息
export const DeleteInputStore = (params) => {
	return reqF("post", "/api/sysConfig/Receipt/DeleteInputStore", params);
};
// 审核入库单信息
export const AuditInputStore = (params) => {
	return reqF("post", "/api/sysConfig/Receipt/AuditInputStore", params);
};
// 生成入库单编号
export const GenerateInputNumber = (params) => {
	return reqF("post", "/api/sysConfig/Receipt/GenerateInputNumber", params);
};

// 分页获取入库明细列表
export const GetInputStoreDtlPageList = (params) => {
	return reqF("post", "/api/sysConfig/Receipt/GetInputStoreDtlPageList", params);
};
// 获取入库单明细信息详情
export const GetInputStoreDtlDetail = (params) => {
	return reqF("post", "/api/sysConfig/Receipt/GetInputStoreDtlDetail", params);
};

// 分页获取出库单列表
export const GetOutputStorePageList = (params) => {
	return reqF("post", "/api/sysConfig/Receipt/GetOutputStorePageList", params);
};
// 获取出库单详情
export const GetOutputStoreDetail = (params) => {
	return reqF("post", "/api/sysConfig/Receipt/GetOutputStoreDetail", params);
};
// 创建出库单
export const CreateOutputStore = (params) => {
	return reqF("post", "/api/sysConfig/Receipt/CreateOutputStore", params);
};
// 加工失败后重新出库
export const RedistributeOutputStore = (params) => {
	return reqF("post", "/api/sysConfig/Receipt/RedistributeOutputStore", params);
};
// 生成出库单号
export const GenerateOutputNumber = (params) => {
	return reqF("post", "/api/sysConfig/Receipt/GenerateOutputNumber", params);
};
// 分页获取出库明细信息列表
export const GetOutputStoreDtlPageList = (params) => {
	return reqF("post", "/api/sysConfig/Receipt/GetOutputStoreDtlPageList", params);
};
// 导出出库单明细数据
export const ExportOutputStoreDtl = (params) => {
	return reqBlob("post", "/api/sysConfig/Receipt/ExportOutputStoreDtl", params);
};
//保存出库单明细修改价格
export const SaveOutputStoreDtlEditPrice = (params) => {
	return reqF("post", "/api/sysConfig/Receipt/SaveOutputStoreDtlEditPrice", params);
};
//创建修改商品的出库单
export const CreateEditOutputStore = (params) => {
	return reqF("post", "/api/sysConfig/Receipt/CreateEditOutputStore", params);
};
// 回退出库单并返还库存，订单状态不变
export const RollbackOutputStore = (params) => reqF("post", "/api/sysConfig/Receipt/RollbackOutputStore", params);

//获取订单出库列表
export const GetOrderOutputList = (params) => {
	return reqF("post", "/api/sysConfig/Receipt/GetOrderOutputList", params);
};

// 分页获取采购单信息列表
export const GetPurchaseOrderPageList = (params) => {
	return reqF("post", "/api/sysConfig/Receipt/GetPurchaseOrderPageList", params);
};
// 导出采购单信息
export const ExportPurchaseOrder = (params) => {
	return reqBlob("post", "/api/sysConfig/Receipt/ExportPurchaseOrder", params);
};
//批量修改采购商品的所属供应商
export const EditPurchaseOrderSupply = (params) => {
	return reqF("post", "/api/sysConfig/Receipt/EditPurchaseOrderSupply", params);
};
// 创建入库单
export const CreateInputStore = (params) => {
	return reqF("post", "/api/sysConfig/Receipt/CreateInputStore", params);
};
// 删除采购单
export const DeletePurchaseOrder = (params) => {
	return reqF("post", "/api/sysConfig/Receipt/DeletePurchaseOrder", params);
};
// 出入库统计（按上线商品类型 × 月份）
export const GetInOutStatistics = (params) => {
	return reqF("post", "/api/sysConfig/Receipt/GetInOutStatistics", params);
};
